import React, { useContext } from 'react';
import { ThemeContext } from '../theme';

const ChevronRight = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 6l6 6-6 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Single row in the Settings left-nav card.
 *
 * Props:
 *   icon     — img src for the row icon
 *   label    — string
 *   active   — boolean
 *   onClick  — () => void
 *   isFirst  — boolean (rounds top corners)
 *   isLast   — boolean (rounds bottom corners, removes border)
 */
export default function SettingsMenuItem({ icon, label, active, onClick, isFirst, isLast }) {
  const theme = useContext(ThemeContext);
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        height: 40,
        padding: '0 14px',
        backgroundColor: active ? theme.settingsActive : theme.cardBg,
        borderBottom: isLast ? 'none' : `1px solid ${theme.border}`,
        borderTopLeftRadius: isFirst ? 16 : 0,
        borderTopRightRadius: isFirst ? 16 : 0,
        borderBottomLeftRadius: isLast ? 16 : 0,
        borderBottomRightRadius: isLast ? 16 : 0,
        cursor: 'pointer',
        flexShrink: 0,
        userSelect: 'none',
        transition: 'background-color 0.15s',
      }}
    >
      {React.createElement(icon, {
        size: 16,
        variant: 'Linear',
        color: active ? '#FFFFFF' : '#8c8c8c',
      })}
      <span
        className="font-satoshi"
        style={{
          flex: 1,
          textAlign: 'left',
          fontSize: 13,
          lineHeight: '18px',
          fontWeight: 500,
          color: active ? '#FFFFFF' : theme.text400,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </span>
      <ChevronRight color={active ? '#FFFFFF' : '#b3c4cb'} />
    </div>
  );
}
